import script from "./TeamInputRow.vue?vue&type=script&setup=true&lang=js"
export * from "./TeamInputRow.vue?vue&type=script&setup=true&lang=js"

import "./TeamInputRow.vue?vue&type=style&index=0&id=a833b15c&lang=scss&scoped=true"

import exportComponent from "../../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-a833b15c"]])

export default __exports__